var RequirePasswordValidate = $.extend({/* RequirePasswordValidate */}, BaseComponent, {

	componentSelector: '#require-data',

	init: function() {
		$(this.componentSelector).each(this.binding.bind(this));
	},

	binding: function(index, element) {

		$(element).validate({
			rules: {
				nif: {
					required: true,
					nifES: true
				},
				birthdate: {
					required: true
				},
               	method: {
					required: true
                }
			},
			submitHandler: function(form) {
				form.submit();
			},
            errorPlacement: function (error, element) {
                if (element.attr('id') == 'birthdate') {
                    error.insertAfter((element).parents('.input-with-icon-calendar'));
                } 
                else if (element.attr('name') == 'method') {
                    error.insertAfter((element).first().next('label'));
                } 
                else {
                    error.insertAfter(element);
                }
            }
		});

		$(element).find('#require-password-submit').click((function(event) {
			event.preventDefault();
			$(element).submit();
		}).bind(this));

	}

})